import { Component, Input } from '@angular/core';
import {
	NavController,
    NavParams } from 'ionic-angular';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { Observable } from 'rxjs';
import { Rodeo } from '../../../../model/rodeo';

@Component({
	selector: 'page-extraruns-report',
	templateUrl: 'report-extra-runs.html'
	
})
export class ExtraRunsReport {
    @Input('rodeo') rodeo: Rodeo;

    documentTitle: any;
    printing: boolean;

    showContactInfo: boolean = true;
    selectedRodeoEvent: any;

    dataLoaded: boolean;
    popoverActive: boolean;

    searchName: string;
    filteredResults: RodeoEventRun[];
    searchChangeObservable: any;

    constructor(private nav: NavController, navParams: NavParams) {
        if (!this.rodeo) {
            this.rodeo = navParams.get('rodeo');
            this.selectedRodeoEvent = navParams.get('selectedRodeoEvent');
        } else if (this.rodeo && this.rodeo.rodeoEvents.length > 0)
            this.selectedRodeoEvent = this.rodeo.rodeoEvents[0];

        this.printing = navParams.get('printing');
        this.showContactInfo = navParams.get('showContactInfo');

        setTimeout(() => {
            this.load();
        }, 0);
    }

    onNameSearchChange(searchValue) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(700)
                .distinctUntilChanged()
                .subscribe((text) => {
                    this.updateRodeoEvent();
                });
        }

        this.searchChangeObservable.next(searchValue);
    }

    updateRodeoEvent() {
        this.filteredResults = [];

        if (this.selectedRodeoEvent == 'All') {
            this.rodeo.rodeoEvents.forEach(rodeoEvent => {
                rodeoEvent.schedules.forEach(schedule => {
                    this.filteredResults.push(...schedule.runs.filter(x => x.isExtraRunForContestantOne || x.isExtraRunForContestantTwo));
                })
            })
        } else if (this.selectedRodeoEvent) {
            this.selectedRodeoEvent.schedules.forEach(schedule => {
                this.filteredResults.push(...schedule.runs.filter(x => x.isExtraRunForContestantOne || x.isExtraRunForContestantTwo));
                console.log('runs: ', schedule.runs);
            })
        }
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    load() {
        this.documentTitle = this.rodeo.name + " - " + 'Extra Runs';
        this.dataLoaded = true;
        this.updateRodeoEvent();
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop(); 
        }, 0);
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        
        this.nav.push(ExtraRunsReport, {
            rodeo: this.rodeo,
            selectedRodeoEvent: this.selectedRodeoEvent,
            showContactInfo: this.showContactInfo,
            printing: true
        }).then(() => { this.popoverActive = false; });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-extra-runs.ts